import { DocLayout } from './DocLayout';

export default function DocTaguri() {
  return (
    <DocLayout title="Tag-uri">
      <h2>Prezentare generală</h2>
      <p>
        Tag-urile sunt etichete atașate activităților pentru filtrare și organizare.
        Ele apar pe paginile publice și ajută utilizatorii să găsească activități relevante.
      </p>

      <h2>Tipuri de tag-uri</h2>
      <ul>
        <li><strong>Tag-uri principale</strong> — categorii majore (ex: Cultură, Sport, Educație). Apar cu culoarea lor pe pagina activității și pot fi folosite pentru filtrare. Se recomandă un număr limitat (5-10).</li>
        <li><strong>Tag-uri secundare</strong> — etichete descriptive mai specifice (ex: Atelier, Workshop, Voluntariat). Apar discret sub descriere.</li>
      </ul>

      <h2>Proprietăți</h2>
      <ul>
        <li><strong>Nume</strong> — textul afișat (obligatoriu).</li>
        <li><strong>Culoare</strong> — culoarea de fundal pentru tag-urile principale. Contrastul textului se calculează automat.</li>
        <li><strong>Icon</strong> — emoji sau icon opțional (doar pentru tag-urile principale).</li>
        <li><strong>Tag principal</strong> — marchează tag-ul ca o categorie majoră.</li>
      </ul>

      <h2>Utilizare</h2>
      <p>
        Tag-urile se asociază cu activitățile din formularul de editare a activității.
        Utilizatorii publici pot filtra activitățile după tag-urile principale din lista de evenimente.
      </p>
    </DocLayout>
  );
}
